<template>
  <div>
    <table class="table-fixed w-full">
      <tr>
        <td class="w-1/5 text-gray-600 font-medium align-top">{{ title }}</td>
        <td class="w-3/5 text-gray-800 align-top">
          <slot></slot>
        </td>
        <td class="w-1/5 text-right text-gray-500 uppercase font-bold tracking-wider align-top">
          <span
            v-if="!isComplete"
            class="cursor-pointer"
            @click="$emit('edit')"
          >Edit</span>
        </td>
      </tr>
    </table>
    <m-divider />
  </div>
</template>

<script>
export default {
  name: 'review-item',
  props: {
    title: {
      type: String,
      required: true,
    },
    step: {
      type: Number,
      default: 0,
    },
    isComplete: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>

</style>
